var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "search-card" }, [
    _c(
      "div",
      { staticClass: "search-card__container" },
      [
        _c(
          "z-link",
          {
            staticClass: "search-card__link",
            attrs: { href: _vm.searchItem.url },
          },
          [_vm._v(_vm._s(_vm.searchItem.title))]
        ),
        _vm._v(" "),
        _c("vue-raw", {
          staticClass: "html-content search-card__text",
          attrs: { raw: _vm.searchItem.text },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.searchItem.date
      ? _c(
          "div",
          { staticClass: "search-card__container" },
          [
            _c(
              "z-caption",
              {
                staticClass: "search-card__subtext",
                attrs: { tag: "p", size: "xs" },
              },
              [_vm._v(_vm._s(_vm.text.dateText))]
            ),
            _vm._v(" "),
            _c(
              "z-caption",
              {
                staticClass: "search-card__subtext",
                attrs: { tag: "p", size: "xs" },
              },
              [
                _vm._v(
                  _vm._s(
                    _vm._f("momentFilter")(_vm.searchItem.date, "DD MMMM YYYY")
                  )
                ),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }